export const mockCmsTemplate = {
  total: 3,
  limit: 50,
  offset: 0,
  results: [
    {
      '@id': '18b81158-8904-4df8-93db-f46b170011b9',
      '@name': 'videos',
      '@path': '/gb/domestic-and-general/self-fix/videos',
      '@nodeType': 'mgnl:page',
      'mgnl:template': 'dgx-self-fix:pages/self-fix-category',
      name: 'videos',
      title: 'Self Fix Category',
      seoKeywords: [],
      'mgnl:lastModified': 1707995522,
      main: {
        '@path': '/gb/domestic-and-general/self-fix/videos/main',
        '@name': 'main',
        '@nodeType': 'mgnl:area',
        '@nodes': [],
      },
      seoOpenGraph: {
        '@path': '/gb/domestic-and-general/self-fix/videos/seoOpenGraph',
        '@name': 'seoOpenGraph',
        image: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/seoOpenGraph/image',
          '@name': 'image',
          position: 'center',
          '@nodes': [],
        },
        article: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/seoOpenGraph/article',
          '@name': 'article',
          tag: [],
          '@nodes': [],
        },
        '@nodes': ['image', 'article'],
      },
      '@nodes': ['main', 'seoOpenGraph'],
    },
    {
      '@id': 'ee528d9f-316e-472f-8245-a1f9af848962',
      '@name': 'repairing',
      '@path': '/gb/domestic-and-general/self-fix/videos/repairing',
      '@nodeType': 'mgnl:page',
      'mgnl:template': 'dgx-self-fix:pages/self-fix-category',
      name: 'repairing',
      title: 'Self Fix Category',
      seoKeywords: [],
      'mgnl:lastModified': 1708472347,
      seoOpenGraph: {
        '@path':
          '/gb/domestic-and-general/self-fix/videos/repairing/seoOpenGraph',
        '@name': 'seoOpenGraph',
        image: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/repairing/seoOpenGraph/image',
          '@name': 'image',
          position: 'center',
          '@nodes': [],
        },
        article: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/repairing/seoOpenGraph/article',
          '@name': 'article',
          tag: [],
          '@nodes': [],
        },
        '@nodes': ['image', 'article'],
      },
      '@nodes': ['seoOpenGraph'],
    },
    {
      '@id': '7f7d953c-648c-4bad-85e3-f08884a6f1a7',
      '@name': 'How-to-wash',
      '@path': '/gb/domestic-and-general/self-fix/videos/How-to-wash',
      '@nodeType': 'mgnl:page',
      'mgnl:template': 'dgx-self-fix:pages/self-fix-category',
      name: 'How-to-wash',
      title: 'Self Fix Category',
      seoKeywords: [],
      'mgnl:lastModified': 1708471318,
      seoOpenGraph: {
        '@path':
          '/gb/domestic-and-general/self-fix/videos/How-to-wash/seoOpenGraph',
        '@name': 'seoOpenGraph',
        image: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/How-to-wash/seoOpenGraph/image',
          '@name': 'image',
          position: 'center',
          '@nodes': [],
        },
        article: {
          '@path':
            '/gb/domestic-and-general/self-fix/videos/How-to-wash/seoOpenGraph/article',
          '@name': 'article',
          tag: [],
          '@nodes': [],
        },
        '@nodes': ['image', 'article'],
      },
      '@nodes': ['seoOpenGraph'],
    },
  ],
};
